import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { GENERATION_STEPS, Job, jobMicroUsd, jobStepModels } from '@quizdb/common';
import { formatMicroUsd } from './formatCost';

/** Props for `JobCostCard`. */
export interface JobCostCardProps {
  job: Job;
}

/**
 * A job's step models (family, effort, model id) and its total cost, translations included
 * (JSM-D3, QZ-D175).
 */
export const JobCostCard = ({ job }: JobCostCardProps) => {
  const { t } = useTranslation();

  const models = jobStepModels(job);

  return (
    <div className="qz-card">
      <div className="qz-card-header">
        <h3>{t('job.page.modelsAndCost')}</h3>
        <span className="qz-mono fw-semibold">{formatMicroUsd(jobMicroUsd(job))}</span>
      </div>
      <div className="qz-card-body">
        <dl className="qz-kv">
          {GENERATION_STEPS.map((step) => {
            const { family, effort, model } = models[step];
            return (
              <Fragment key={step}>
                <dt>{t(`job.step.${step}`)}</dt>
                <dd>
                  {t(`job.family.${family}`)} · {t(`job.effort.${effort}`)}
                  <div className="qz-mono qz-small qz-muted">{model}</div>
                </dd>
              </Fragment>
            );
          })}
        </dl>
      </div>
    </div>
  );
};
